import React from "react";
import ContatoTipoService from "../../services/ContatoTipoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaContatoTipo extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: ContatoTipoService,
            labels: {
                title: 'Lista de Tipo(s)',
                btnNewRegister: 'Tipo',
            },
            keyItem: 'idContatoTipo',
            urlForm: '/CadContatoTipo',
            itensFilter: ["idContatoTipo", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idContatoTipo}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}